export default {
  OPEN_POPUP: "openPopup",
  CLOSE_POPUP: "closePopup",
  CONFIRM: "confirm",
  DECLINE: "decline",
};
